// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wG-z","hovered":"xG-z","hoverImage":"yG-z","mainImage":"zG-z","imageNoBackground":"AG-z","fullSizeImage":"BG-z"};